import React from 'react';
import APIContent from '../md/api.mdx';

function API() {
  return <APIContent />;
}

// 12
export default API;
